import React from "react";
import { withStyles } from "material-ui/styles";
import { CircularProgress } from "material-ui/Progress";

const styles = {
  root: {
    flexGrow: 1,
    flexDirection: "row",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginTop: 100
  }
};

const CenteredProgress = props => (
  <div className={props.classes.root}>
    <CircularProgress />
  </div>
);

export { CenteredProgress };

export default withStyles(styles, { name: "CenteredProgress" })(
  CenteredProgress
);



// WEBPACK FOOTER //
// ./src/CenteredProgress.js